import React from 'react';
import { Breadcrumb, Button, Card, message } from 'antd';

import BannerModal from './modal';
import BannersTable from './table';
import SortBannerCard from './sort-banner-card'
import './index.css';

import { _getAllBanners, 
    _postBanner, 
    _postDeleteOneBanner, 
    _postUpdatedBanner, 
    _postUpdateBannersAfterArranging 
} from '../../services';

class BannersComponent extends React.Component{
    render() {

        const { activeData, banners, editSequence, visible } = this.state;

        return(
            <Card 
                title={
                    <div>
                        <Breadcrumb separator="|">
                            <Breadcrumb.Item>Home Page</Breadcrumb.Item>
                            <Breadcrumb.Item className="active-breadcrumb">Banner</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>}
                extra={
                    <div>
                        <Button 
                            onClick={this.toggleModalActive}>
                            Add new banner
                        </Button>

                        {/* <Button onClick={this.handleEdit}>
                            Edit Sequence
                        </Button> */}
                    </div>
                }>

                { ( banners.length>=1) ?
                    <div>
                        <SortBannerCard 
                        editSequence={editSequence}
                        closeSequenceModal={this.closeSequenceModal}
                        banners={banners}
                        submitBannerSequence={this.submitBannerSequence}
                        edittingSequence={this.edittingSequence}/>
                    </div>
                    :
                    null
                }
                { !banners?
                    <div>hi</div>
                    :
                    <BannersTable 
                        banners={banners}
                        deleteOneBanner={this.deleteOneBanner}
                        editBanner={this.toggleModalActive}/>
                }
                {visible?
                    <BannerModal 
                        handleCancel={this.closeModal}
                        handleSubmit={this.handleSubmit}
                        visible={visible}
                        banner={activeData}
                    />
                    :
                    null
                }
                {/* {(featuredCategories)?
                <Row>

                    {(featuredCategories.length <1)?
                        <div>
                            No Featured Categories
                        </div> 
                    : 
                        <SortableFeaturedList 
                        featuredCategories={featuredCategories}
                        toggleActive={this.toggleActive}
                        onEdit={this.onEdit}
                        updateEdited={this.updateEdited}
                        updateFeaturedCategories={this.updateFeaturedCategories}
                    />
                    }
                    
                </Row>
                :
                ''
                } */}

                

            </Card>
        )
    }
    
    constructor(props) {
        super(props);
        this.state = {
            activeData: {
				active: true,
                link: '',
                name: '',
                // position: null,
                image: null,
                title: '',
                src: '',
            },
            banners: [],
            editSequence: false,
			emptyData: {
                // _id: '',
				active: true,
                link: '',
                name: '',
                // position: null,
                image: null,
                title: '',
                src: '',
			},
			visible: false
        }
        // _getAllBanners()
        // .then( res => {
        //     // conosle.log(res);
        // })
        _getAllBanners()
        .then( res => {
            // console.log(res.data)
            this.setState({
                banners: false
            })
            this.setState({
                banners: res.data.banners
            })
            // console.log("state = " , this.state.data)
        })
    }

    closeModal = () => {
		this.setState({
			activeData: this.state.emptyData,
			visible: false
		})
    }

    closeSequenceModal = () => {
        this.setState({
            editSequence: false
        })
    }

    deleteOneBanner = (bannerId) => {
        _postDeleteOneBanner(bannerId)
        .then( res => {
            this.setState({
                banners: res.data.banners
            })
        })
    }    
    
    handleEdit = () => {
        // console.log(this.state.banners)
        this.setState({
            editSequence: true,
        })
    }

    handleSubmit = (banner) => {
        // console.log("banner" , banner)
        // console.log(banner)
        if(banner._id) {
            _postUpdatedBanner(banner, banner._id)
            .then( res => {
                // console.log("updated res = " , res)
                this.setState({
                    banners: res.data.banners
                })
            })
            .then( () => this.setState({visible: false}))
            return;
        }
        _postBanner(banner)
        .then( res => {
            // console.log("returned banners" , res)
            if(res.data.banners) {
                this.setState({
                    banners: res.data.banners
                })
            }
        })  
        .then( () => this.setState({visible: false}))

        
    }
    
    submitBannerSequence = (banners) => {
        // const _ids = banners.filter( banner => banner._id );
        _postUpdateBannersAfterArranging(banners)
        .then( res => {
            // console.log(" after arranging = " , res.data.banners)
            if(res.data.banners) {
                this.setState({
                    banners: res.data.banners,
                })
                message.success("Updated")
            }
        })
        .then( () => this.setState({
            editSequence: false
        }))
        //submit sequence
    }

    edittingSequence = () => {
        this.setState({
            editSequence: true
        })
    }

    toggleModalActive = ( props ) => {
		// console.log("toggled active", props)
		if(props._id === null) {
			this.setState({
                visible: true,
                // activeData: {
                //     ...this.state.activeData,
                //     // position: this.state.banners.length +1
                // }
			})
		} else {
			this.setState({
                activeData: props,
                visible: true
            })
		}
	}
}

export default BannersComponent;


// WEBPACK FOOTER //
// ./src/components/banners/index.js